import React from 'react'

interface SvgProps {
  className?: string
}

export function BuyOutWhite({ className }: SvgProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.06 49.07">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M104.67 37.55c-2.25-1.72-3.68-2.84-3.68-4.38a2.59 2.59 0 012.71-2.67c2.54 0 3 2.88 3 3.49v.31h2v-.49c0-2.58-1.63-5.34-5-5.34a4.53 4.53 0 00-4.7 4.7c0 2.64 1.66 3.95 4.26 5.91s3.87 2.64 3.87 4.78a3 3 0 01-3.44 3.14 3.8 3.8 0 01-3.58-4h-2a5.75 5.75 0 005.6 6 5 5 0 005.37-5.27c-.02-2.96-1.4-3.92-4.41-6.18zM80.37 40c0 4.58-1.41 7-4.5 7s-4.5-2.44-4.5-7V28.6h-2V40c0 5.81 2 9 6.52 9s6.52-3.24 6.52-9V28.6h-2zM51.68 18.4a8 8 0 002.65-.4c-.16-.12-1.5-1.25-2.11-1.67h-.69A6.45 6.45 0 0147 14.2a6.62 6.62 0 01-1.17-1.67 7.19 7.19 0 01-.7-2.19A8.5 8.5 0 0145 9.2a8.74 8.74 0 01.08-1.14 7.14 7.14 0 01.7-2.18A6.62 6.62 0 0147 4.21a6.42 6.42 0 014.55-2.08h.69c.61-.41 2-1.54 2.11-1.67a8.25 8.25 0 00-8.79 2.24 9.22 9.22 0 00-2 3.26 9.54 9.54 0 00-.48 2.13 8.92 8.92 0 000 2.23 9.46 9.46 0 00.48 2.12 9.22 9.22 0 002 3.26 8.39 8.39 0 005.92 2.7z"
            className="cls-1"
          ></path>
          <path
            d="M90 28.6L85.4 28.6 85.4 30.74 90 30.74 90 48.88 92.03 48.88 92.03 30.74 96.63 30.74 96.63 28.6 92.03 28.6 90 28.6z"
            className="cls-1"
          ></path>
          <path
            d="M55.71 28.47c-5.32 0-9.58 4.66-9.58 10.3S50.39 49 55.71 49s9.64-4.65 9.64-10.23-4.26-10.3-9.64-10.3zm0 18.57c-4.22 0-7.6-3.85-7.6-8.27s3.45-8.33 7.66-8.33 7.66 3.92 7.66 8.33S60 47 55.71 47zM60.42 16.27a6 6 0 01-2.61-.5 6.41 6.41 0 01-1.74-1.09L56 14.6a16.51 16.51 0 00-2.54-1.87A18 18 0 0050 11.22a19.66 19.66 0 00-3.32-.73 5.54 5.54 0 001.17 2.35c.53.12 1.06.26 1.57.42a16.29 16.29 0 013.07 1.34 13.77 13.77 0 011.66 1.17l.66.56a8.56 8.56 0 001.17.86 8.29 8.29 0 004.29 1.22h.2a8.39 8.39 0 005.93-2.7A9.09 9.09 0 0067.63 14h-2.56a6.45 6.45 0 01-4.65 2.27zM5.7 48.88A5.8 5.8 0 0011.27 43a6 6 0 00-2.87-5.18A5.49 5.49 0 0010 34a5.29 5.29 0 00-5.09-5.4H0v20.28h5.7zM2 30.74h2.91A3.16 3.16 0 017.85 34a3 3 0 01-2.94 3.06H2zm0 8.46h3.7a3.79 3.79 0 010 7.54H2zM52.48 3.8a15.1 15.1 0 01-3.07 1.34 14 14 0 01-1.57.42 5.64 5.64 0 00-1.17 2.36A19.68 19.68 0 0050 7.18a17.68 17.68 0 003.44-1.51A15.88 15.88 0 0056 3.8l.1-.08a6.35 6.35 0 019 .6h2.56a10 10 0 00-1.27-1.62A8.43 8.43 0 0060.46 0 8.22 8.22 0 0056 1.22a8.48 8.48 0 00-1.17.85l-.66.56a11.84 11.84 0 01-1.69 1.17z"
            className="cls-1"
          ></path>
          <path
            d="M62.53 5.14q-.39-.12-.78-.27l-.25-.09-.26-.11-.24-.1-.49-.23-.24-.11-.27-.12-.57-.31a5.11 5.11 0 00-2.26 1 12.94 12.94 0 001.31.87L59 6a16.9 16.9 0 003 1.18 19.67 19.67 0 004.87.88H77.3V6h-9.65c-.51 0-1 0-1.51-.08a17.26 17.26 0 01-3.61-.78zM42 6H31.76v2.09h9.81A11.62 11.62 0 0142 6zM77.3 10.32H66.83a19.67 19.67 0 00-4.87.88 18 18 0 00-3.45 1.51 12.94 12.94 0 00-1.31.87 5 5 0 002.26 1l.81-.43.17-.08.26-.07a16.89 16.89 0 011.83-.71 17.38 17.38 0 013.61-.73c.54 0 1.08-.08 1.63-.09h9.53zM41.57 10.32h-9.81v2.12H42a11.52 11.52 0 01-.43-2.12z"
            className="cls-1"
          ></path>
          <path
            d="M38.13 37.54L33.13 28.6 30.77 28.6 37.08 39.92 37.12 39.9 37.12 48.88 39.14 48.88 39.14 39.9 39.17 39.92 45.48 28.6 43.13 28.6 38.13 37.54z"
            className="cls-1"
          ></path>
          <path
            d="M25.51 39.84v.21c0 3.6-1.07 7-4.5 7s-4.51-3.39-4.51-7V28.6h-2v11.74c0 4.71 1.71 8.73 6.53 8.73s6.52-4 6.52-8.73V28.6h-2z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function DownArrowGreen({ className }: SvgProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 13.42">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M13.47 4.21H17.91V6.29H13.47z"
            className="cls-1"
            transform="rotate(-45 15.686 5.253)"
          ></path>
          <path
            d="M10.53 1.27H14.969999999999999V3.35H10.53z"
            className="cls-1"
            transform="rotate(-45 12.747 2.31)"
          ></path>
          <path
            d="M6.05 7.54L1.47 2.96 0 4.43 4.58 9.01 8.99 13.42 10.46 11.95 6.05 7.54z"
            className="cls-1"
          ></path>
          <path
            d="M4.41 0.02L2.94 1.49 7.52 6.07 11.93 10.48 13.4 9.01 4.41 0.02z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function DownArrowNavy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 13.42">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M13.47 4.21H17.91V6.29H13.47z"
            className="cls-1"
            transform="rotate(-45 15.686 5.253)"
          ></path>
          <path
            d="M10.53 1.27H14.969999999999999V3.35H10.53z"
            className="cls-1"
            transform="rotate(-45 12.747 2.31)"
          ></path>
          <path
            d="M6.05 7.54L1.47 2.96 0 4.43 4.58 9.01 8.99 13.42 10.46 11.95 6.05 7.54z"
            className="cls-1"
          ></path>
          <path
            d="M4.41 0.02L2.94 1.49 7.52 6.07 11.93 10.48 13.4 9.01 4.41 0.02z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function DropPinGreen({ className, onMouseOver, onMouseLeave, onClick }: any) {
  return (
    <svg
      className={className}
      onMouseLeave={() => onMouseLeave()}
      onMouseOver={() => onMouseOver()}
      onClick={() => onClick()}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.47 30.75"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M21.74 3.73a12.74 12.74 0 00-18 18l4.6 4.6 4.42 4.42 1.47-1.47-4.44-4.42-4.6-4.6a10.66 10.66 0 1115.08 0l-3.14 3.14 1.47 1.47 3.14-3.14a12.72 12.72 0 000-18z"
            className="cls-1"
          ></path>
          <path
            d="M8.15 8.14a6.49 6.49 0 019.18 9.18l-3.14 3.14 1.47 1.48 3.14-3.15a8.57 8.57 0 10-12.13 0l4.59 4.6 4.42 4.41 1.47-1.47-9-9a6.38 6.38 0 010-9.19z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function DropPinNavy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.47 30.75">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M21.74 3.73a12.74 12.74 0 00-18 18l4.6 4.6 4.42 4.42 1.47-1.47-4.44-4.42-4.6-4.6a10.66 10.66 0 1115.08 0l-3.14 3.14 1.47 1.47 3.14-3.14a12.72 12.72 0 000-18z"
            className="cls-1"
          ></path>
          <path
            d="M8.15 8.14a6.49 6.49 0 019.18 9.18l-3.14 3.14 1.47 1.48 3.14-3.15a8.57 8.57 0 10-12.13 0l4.59 4.6 4.42 4.41 1.47-1.47-9-9a6.38 6.38 0 010-9.19z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function GrowthWhite({ className }: SvgProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 107.23 49.07">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M29.38 10.34v2.13h10.89a10.07 10.07 0 01-.44-2.13zM40.27 6H29.38v2.11h10.45A10.2 10.2 0 0140.27 6zM50.42 16.31a7.05 7.05 0 01-4.84-2.08 7 7 0 01-1.25-1.67 7.17 7.17 0 01-.74-4.48 7.27 7.27 0 01.74-2.19 7 7 0 011.25-1.67 7.05 7.05 0 014.84-2.08h.74c.65-.41 2.08-1.55 2.25-1.67a9.14 9.14 0 00-9.34 2.26A9.06 9.06 0 0042 6a9 9 0 00-.52 2.13 8.92 8.92 0 000 2.23 9 9 0 00.52 2.11 9.06 9.06 0 002.11 3.27 9.23 9.23 0 006.3 2.71h.21a9.1 9.1 0 002.79-.45c-.17-.12-1.6-1.26-2.25-1.67z"
            className="cls-1"
          ></path>
          <path
            d="M51.44 3.81a16.87 16.87 0 01-3.27 1.34 15.86 15.86 0 01-1.68.42 5.52 5.52 0 00-1.24 2.37 21.68 21.68 0 003.53-.74 19.91 19.91 0 003.67-1.51 17.46 17.46 0 002.7-1.88l.1-.08a7.05 7.05 0 014.63-1.59 7.05 7.05 0 014.95 2.19h2.72a9.44 9.44 0 00-1.32-1.66 9.19 9.19 0 00-12.33-.59l-.7.56a12.8 12.8 0 01-1.76 1.17zM59.72 18.45h.21a9.24 9.24 0 007.62-4.38h-2.72a7.06 7.06 0 01-7.73 1.69 7 7 0 01-1.85-1.09l-.1-.08a17.46 17.46 0 00-2.7-1.88 19.91 19.91 0 00-3.67-1.51 21.68 21.68 0 00-3.53-.74 5.43 5.43 0 001.24 2.36q.85.18 1.68.42a17.27 17.27 0 013.27 1.35 13.44 13.44 0 011.76 1.17l.7.56a9.22 9.22 0 005.82 2.08z"
            className="cls-1"
          ></path>
          <path
            d="M66.71 10.37a22.1 22.1 0 00-5.19.88 19.13 19.13 0 00-3.67 1.51 14.84 14.84 0 00-1.39.87 5.44 5.44 0 002.4 1c.29-.16.57-.3.87-.44l.17-.08.28-.12a18.08 18.08 0 012-.71 19.32 19.32 0 013.82-.72c.57-.05 1.15-.08 1.73-.09h10.12v-2.13H67.7c-.34 0-.7.01-.99.03zM66 5.89a20.06 20.06 0 01-3.84-.73l-.83-.27-.33-.1-.27-.1-.27-.11-.46-.23-.25-.11-.24-.12-.61-.31a5.44 5.44 0 00-2.4 1 14.84 14.84 0 001.39.87l.54.28a20.36 20.36 0 003.09 1.24 22.1 22.1 0 005.19.88h11.14V6H67.58C67 6 66.5 5.94 66 5.89zM27.92 34.07a5.45 5.45 0 00-5.34-5.41h-5.29V49h2.15v-9.71h.8L27.18 49H30l-7.07-9.71a5.3 5.3 0 004.99-5.22zm-8.48 3.07v-6.33h3.14a3.25 3.25 0 013.07 3.26 3.08 3.08 0 01-3.07 3.07z"
            className="cls-1"
          ></path>
          <path
            d="M78.56 30.81L83.46 30.81 83.46 49 85.61 49 85.61 30.81 90.5 30.81 90.5 28.66 78.56 28.66 78.56 30.81z"
            className="cls-1"
          ></path>
          <path
            d="M105.08 37.14L96.6 37.14 96.6 28.66 94.45 28.66 94.45 49 96.6 49 96.6 39.29 105.08 39.29 105.08 49 107.23 49 107.23 28.66 105.08 28.66 105.08 37.14z"
            className="cls-1"
          ></path>
          <path
            d="M69.42 44.95L65.69 28.66 63.82 28.66 63.82 28.66 63.82 28.66 60.09 44.95 56.72 28.66 54.45 28.66 58.94 49 61.19 49 64.75 32.89 68.32 49 70.57 49 75.06 28.66 72.78 28.66 69.42 44.95z"
            className="cls-1"
          ></path>
          <path
            d="M52 38.81a10.23 10.23 0 10-10.25 10.26A10.27 10.27 0 0052 38.81zm-10.28 8a8 8 0 01-7.78-8 7.84 7.84 0 117.78 8zM10.53 37.19H7.41v2.05h3.12v7.48h-.33a8 8 0 01-8-7.86 8.12 8.12 0 018-8h.43v-2.2h-.43a10.17 10.17 0 100 20.34h2.37V37.18h-2z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function HamburgerGreen() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.25 6.24">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path d="M0 0H24.25V2.08H0z" className="cls-1"></path>
          <path d="M0 4.16H24.25V6.24H0z" className="cls-1"></path>
        </g>
      </g>
    </svg>
  )
}

export function HamburgerNavy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.25 6.24">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path d="M0 0H24.25V2.08H0z" className="cls-1"></path>
          <path d="M0 4.16H24.25V6.24H0z" className="cls-1"></path>
        </g>
      </g>
    </svg>
  )
}

export function InfrastructureWhite({ className }: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={`${className}`} viewBox="0 0 248.97 56.71">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M96.54 11.92v2.46h12.55a12.49 12.49 0 01-.51-2.46zm12.55-5.03H96.54v2.46h12a12.8 12.8 0 01.55-2.46zm11.71 11.92a8.21 8.21 0 01-5.59-2.4 8.33 8.33 0 01-1.43-1.93 8.07 8.07 0 01-.85-2.52 8.4 8.4 0 01-.11-1.32 8.2 8.2 0 01.11-1.32 8 8 0 01.85-2.53 8.33 8.33 0 011.43-1.93 8.21 8.21 0 015.59-2.4h.85C122.4 2 124 .65 124.24.51A10.63 10.63 0 00111 6.89a10.29 10.29 0 00-.6 2.46 10.36 10.36 0 000 2.57 10.17 10.17 0 00.6 2.46 10.76 10.76 0 002.43 3.77 10.62 10.62 0 007.27 3.12h.3a10.66 10.66 0 003.25-.51c-.19-.14-1.84-1.45-2.59-1.93z"
            className="cls-1"
          ></path>
          <path
            d="M122 4.39a20.39 20.39 0 01-3.77 1.54c-.63.19-1.27.35-1.93.49a6.22 6.22 0 00-1.43 2.72 25.13 25.13 0 004.07-.85 22.63 22.63 0 004.23-1.74 20.16 20.16 0 003.11-2.17l.12-.09A8.13 8.13 0 01128.5 3a8.26 8.26 0 013.21-.58A8.16 8.16 0 01137.42 5h3.14A10.75 10.75 0 00139 3.12a10.55 10.55 0 00-14.22-.72c-.26.21-.53.43-.81.64A15.22 15.22 0 01122 4.39zm9.76 16.88a10.59 10.59 0 007.24-3.12 10.75 10.75 0 001.53-1.92l-3.14.05a8.16 8.16 0 01-5.71 2.53 8.26 8.26 0 01-3.21-.58 8.13 8.13 0 01-2.1-1.23l-.12-.09a20.65 20.65 0 00-3.11-2.17 23.32 23.32 0 00-4.23-1.74 26.25 26.25 0 00-4.07-.85 6.31 6.31 0 001.43 2.73c.66.13 1.3.29 1.93.48a19.75 19.75 0 013.8 1.52 15.22 15.22 0 012 1.35c.28.21.55.43.81.65a11.51 11.51 0 001.44 1 10.59 10.59 0 005.27 1.4z"
            className="cls-1"
          ></path>
          <path
            d="M133.6 13a22.91 22.91 0 00-4.23 1.74 16.23 16.23 0 00-1.61 1 6.29 6.29 0 002.77 1.16c.32-.18.65-.34 1-.5l.21-.1.32-.14a20 20 0 012.25-.81 22 22 0 014.42-.85c.66-.06 1.33-.09 2-.1h11.7v-2.48h-12.85A25 25 0 00133.6 13zm.7-7c-.32-.1-.64-.2-1-.32l-.3-.16-.31-.12-.31-.12-.58-.28-.28-.13-.29-.14-.69-.36a6.41 6.41 0 00-2.77 1.16 16.23 16.23 0 001.61 1l.62.32a21.85 21.85 0 003.6 1.45 25.54 25.54 0 006 1h12.88V6.89h-11.89c-.63 0-1.25 0-1.86-.1A23 23 0 01134.3 6zM80.85 33.05L73.54 56.5h2.76l2.25-7.5h7.53l2.22 7.5h2.76l-7.31-23.45zm-1.53 13.44l3-10 3 10zm-10.59-7.2a6.28 6.28 0 00-6.16-6.24h-6.1V56.5H59V45.31h.92l8 11.19h3.19l-8.19-11.19a6.13 6.13 0 005.81-6.02zM59 42.83v-7.3h3.62a3.74 3.74 0 013.54 3.76 3.55 3.55 0 01-3.54 3.54zm-19.27-9.78V56.5h2.48V45.31h7.15v-2.48h-7.15v-7.3h9.77v-2.48H39.73zm-8.08 18.89L19.32 33.05h-2.48V56.5h2.48V37.61L31.65 56.5h2.48V33.05h-2.48v18.89zM0 35.53h4.56v18.49H0v2.48h11.6v-2.48H7.04V35.53h4.56v-2.48H0v2.48zm163.65 9.28a11.71 11.71 0 0011.76 11.69h.49v-2.62h-.49a9.18 9.18 0 01-9.28-9.07 9.36 9.36 0 019.28-9.28h.49v-2.48h-.49a11.73 11.73 0 00-11.76 11.76zm-24.77-5.52a6.28 6.28 0 00-6.16-6.24h-6.09V56.5h2.48V45.31h.89l8 11.19h3.19l-8.15-11.19a6.13 6.13 0 005.84-6.02zm-9.77 3.54v-7.3h3.61a3.74 3.74 0 013.54 3.76 3.55 3.55 0 01-3.54 3.54zM231 39.29a6.28 6.28 0 00-6.16-6.24h-6.1V56.5h2.48V45.31h.92l8 11.19h3.19l-8.15-11.19a6.13 6.13 0 005.82-6.02zm-9.78 3.54v-7.3h3.62a3.74 3.74 0 013.54 3.76 3.55 3.55 0 01-3.54 3.54zm-106.13-9.78h-5.65v2.48h5.65V56.5h2.48V35.53h5.65v-2.48h-8.13zm70.29 0h-5.65v2.48h5.65V56.5h2.48V35.53h5.64v-2.48h-8.12zm63.59 2.48v-2.48h-12.26V56.5h12.26v-2.48h-9.78v-8.71h7.16v-2.48h-7.16v-7.3h9.78zm-147.16 7.86c-2.76-2-4.52-3.28-4.52-5a3.15 3.15 0 013.33-3.16c3.12 0 3.62 3.4 3.62 4.11v.35h2.48v-.57a5.92 5.92 0 00-6.1-6.16c-3.47 0-5.81 2.32-5.81 5.43s2 4.56 5.23 6.82 4.75 3.06 4.75 5.53c0 1.91-1.21 3.68-4.18 3.68a4.49 4.49 0 01-4.39-4.61h-2.48a6.8 6.8 0 006.87 7c4.25 0 6.58-2.69 6.58-6.09s-1.7-4.72-5.38-7.33zm109.44 2.86c0 5.3-1.73 8.12-5.52 8.12s-5.53-2.82-5.53-8.12v-13.2h-2.48v13.2c0 6.72 2.41 10.46 8 10.46s8-3.74 8-10.46v-13.2h-2.48zm-53.47 0c0 5.3-1.74 8.12-5.53 8.12s-5.53-2.82-5.53-8.12v-13.2h-2.48v13.2c0 6.72 2.42 10.46 8 10.46s8-3.74 8-10.46v-13.2h-2.48z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function LeftArrowGreen({ className }: any) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.42 18">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M5.95 14.65H10.39V16.73H5.95z"
            className="cls-1"
            transform="rotate(45 8.17 15.694)"
          ></path>
          <path
            d="M8.9 11.71H13.34V13.790000000000001H8.9z"
            className="cls-1"
            transform="rotate(45 11.12 12.746)"
          ></path>
          <path
            d="M5.89 6.05L10.46 1.47 8.99 0 4.41 4.58 0 8.99 1.47 10.46 5.89 6.05z"
            className="cls-1"
          ></path>
          <path
            d="M13.4 4.41L11.93 2.94 7.36 7.52 2.94 11.93 4.41 13.4 13.4 4.41z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function LeftArrowNavy({ className, onClick }: any) {
  return (
    <svg
      onClick={() => onClick()}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.42 18"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M5.95 14.65H10.39V16.73H5.95z"
            className="cls-1"
            transform="rotate(45 8.17 15.694)"
          ></path>
          <path
            d="M8.9 11.71H13.34V13.790000000000001H8.9z"
            className="cls-1"
            transform="rotate(45 11.12 12.746)"
          ></path>
          <path
            d="M5.89 6.05L10.46 1.47 8.99 0 4.41 4.58 0 8.99 1.47 10.46 5.89 6.05z"
            className="cls-1"
          ></path>
          <path
            d="M13.4 4.41L11.93 2.94 7.36 7.52 2.94 11.93 4.41 13.4 13.4 4.41z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function LogoGreen({ className, onClick }: SvgProps) {
  return (
    <svg
      onClick={onClick ? () => onClick() : () => console.log(null)}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48.36 18.41"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M0 10.32v2.12h10.86a10.64 10.64 0 01-.44-2.12zM10.86 6H0v2.09h10.42A10.89 10.89 0 0110.86 6zM12.55 12.44a9.21 9.21 0 008.39 6h.21A9.08 9.08 0 0024 18c-.17-.12-1.59-1.25-2.24-1.67h-.74a7 7 0 01-4.83-2.07 6.9 6.9 0 01-1.24-1.67 6.75 6.75 0 01-.74-2.19 7.11 7.11 0 01-.09-1.14 7.3 7.3 0 01.09-1.14 6.7 6.7 0 01.74-2.18 6.9 6.9 0 011.24-1.67A7 7 0 0121 2.13h.74C22.38 1.7 23.8.57 24 .44A9.51 9.51 0 0021 0a9.22 9.22 0 00-6.29 2.7A9.17 9.17 0 0012 8.09a8.92 8.92 0 000 2.23 9 9 0 00.55 2.12z"
            className="cls-1"
          ></path>
          <path
            d="M22 3.8a16.44 16.44 0 01-3.25 1.34 15.86 15.86 0 01-1.68.42 5.53 5.53 0 00-1.23 2.36 21.67 21.67 0 003.51-.74A18.88 18.88 0 0023 5.67a17 17 0 002.7-1.87l.1-.08a7 7 0 019.56.6h2.71a9.86 9.86 0 00-1.3-1.62 9.24 9.24 0 00-12.31-.63c-.22.19-.46.38-.7.56A12.22 12.22 0 0122 3.8zM30.43 16.27a7.05 7.05 0 01-4.62-1.59l-.1-.08A18 18 0 0023 12.73a19.91 19.91 0 00-3.67-1.51 21.65 21.65 0 00-3.51-.73 5.33 5.33 0 001.23 2.35c.57.12 1.13.26 1.67.42A17.73 17.73 0 0122 14.6a14.15 14.15 0 011.76 1.17l.7.56a9.22 9.22 0 005.81 2.08h.21a9.17 9.17 0 006.29-2.7A9.53 9.53 0 0038.09 14h-2.72a7 7 0 01-4.94 2.27z"
            className="cls-1"
          ></path>
          <path
            d="M48.36 12.44v-2.12H37.23a21.93 21.93 0 00-5.17.88 19.41 19.41 0 00-3.66 1.51 13.64 13.64 0 00-1.4.89 5.27 5.27 0 002.39 1c.28-.15.56-.29.86-.43l.17-.08.28-.12a18.08 18.08 0 011.95-.71 19.12 19.12 0 013.82-.73q.86-.07 1.74-.09zM32.68 5.15l-.83-.27-.27-.1-.27-.11-.31-.1-.53-.23-.25-.11-.22-.12c-.21-.1-.41-.2-.6-.31a5.5 5.5 0 00-2.4 1 12.09 12.09 0 001.39.87c.17.1.35.19.53.28a18.51 18.51 0 003.13 1.23 21.93 21.93 0 005.17.88h11.14V6H38.11c-.54 0-1.08 0-1.61-.08a19.86 19.86 0 01-3.82-.77z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function MainSiteLogo({ className, homePage, onClick }: any) {
  return (
    <svg
      onClick={onClick ? () => onClick() : null}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 109.92 49.07"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M30.66 10.32v2.12h10.85a10.63 10.63 0 01-.43-2.12zM41.51 6H30.66v2.09h10.42A10.87 10.87 0 0141.51 6zM43.2 12.44a9.25 9.25 0 002.11 3.26 9.15 9.15 0 006.29 2.7h.21a9 9 0 002.81-.4c-.17-.12-1.59-1.25-2.24-1.67h-.73a7.09 7.09 0 01-4.84-2.07 7.17 7.17 0 01-1.24-1.67 7 7 0 01-.73-2.19 7.11 7.11 0 01-.1-1.14 7.31 7.31 0 01.1-1.14 6.93 6.93 0 01.73-2.18 7.17 7.17 0 011.24-1.67 7.05 7.05 0 014.84-2.08h.73C53 1.7 54.45.57 54.62.44a9.4 9.4 0 00-3-.44 9.24 9.24 0 00-8.4 6 9.61 9.61 0 00-.52 2.13 10.39 10.39 0 000 2.23 9.52 9.52 0 00.5 2.08z"
            className="cls-1"
          ></path>
          <path
            d="M52.66 3.8a16.53 16.53 0 01-3.26 1.34 15.68 15.68 0 01-1.67.42 5.44 5.44 0 00-1.24 2.36A21.79 21.79 0 0050 7.18a19.41 19.41 0 003.66-1.51 17.42 17.42 0 002.7-1.87l.09-.08a7.43 7.43 0 011.85-1.09 7.15 7.15 0 012.77-.5A7 7 0 0166 4.32h2.72a9.44 9.44 0 00-1.3-1.62 9.15 9.15 0 00-11.06-1.48 9.1 9.1 0 00-1.24.85c-.23.19-.46.38-.7.56a12.8 12.8 0 01-1.76 1.17zM61.08 16.27a6.8 6.8 0 01-2.77-.5 7.14 7.14 0 01-1.85-1.09l-.1-.08a17.53 17.53 0 00-2.69-1.87A19.81 19.81 0 0050 11.22a21.77 21.77 0 00-3.52-.73 5.35 5.35 0 001.24 2.35c.57.12 1.12.26 1.67.42a17.83 17.83 0 013.26 1.34 14.93 14.93 0 011.76 1.17l.7.56a9.11 9.11 0 005.8 2.08h.21A9.26 9.26 0 0068.74 14h-2.71a7 7 0 01-4.95 2.27z"
            className="cls-1"
          ></path>
          <path
            d="M79 12.44v-2.12H67.88a22.11 22.11 0 00-5.17.88 20 20 0 00-3.66 1.51 14.84 14.84 0 00-1.39.87 5.31 5.31 0 002.4 1l.86-.43.18-.08.28-.12a17.17 17.17 0 011.94-.71 19.22 19.22 0 013.83-.73c.57 0 1.15-.08 1.73-.09zM63.33 5.15l-.83-.27-.27-.1-.23-.11-.27-.1-.52-.23-.25-.11-.25-.12-.6-.31a5.54 5.54 0 00-2.4 1 13 13 0 001.39.87l.5.33a18.4 18.4 0 003.12 1.23 21.93 21.93 0 005.17.88H79V6H68.77c-.54 0-1.08 0-1.61-.08a20 20 0 01-3.83-.77z"
            className="cls-1"
          ></path>
          <path
            d="M22.8 28.6a10.14 10.14 0 1010.11 10.17A10.12 10.12 0 0022.8 28.6zm0 18a7.87 7.87 0 01-7.8-7.83 8 8 0 017.85-8 8.08 8.08 0 018 8 7.93 7.93 0 01-8.05 7.85zM0 38.77a10.13 10.13 0 0010.17 10.11h.43v-2.26h-.43a8 8 0 01-8-7.85 8.1 8.1 0 018-8h.43V28.6h-.43A10.14 10.14 0 000 38.77zM71.53 28.6l-6.32 20.28h2.39l1.94-6.45h6.52L78 48.88h2.39L74 28.6zM70.2 40.23l2.62-8.69 2.58 8.69zM47 34a5.44 5.44 0 00-5.4-5.39h-5.2v20.27h2.14V39.2h.8l6.92 9.68H49l-7.11-9.68A5.22 5.22 0 0047 34zm-8.46 3.07v-6.33h3.06A3.25 3.25 0 0144.71 34a3.09 3.09 0 01-3.13 3.07zM102.87 39.2a5.29 5.29 0 005-5.21 5.43 5.43 0 00-5.33-5.39H97.3v20.28h2.14V39.2h.8l6.92 9.68h2.76zm-3.43-2.14v-6.32h3.13a3.24 3.24 0 013.06 3.26 3.07 3.07 0 01-3.06 3.07zM58.26 37.55c-2.39-1.72-3.91-2.84-3.91-4.38a2.67 2.67 0 012.88-2.67c2.69 0 3.13 2.88 3.13 3.49v.31h2.15v-.49a5.13 5.13 0 00-5.28-5.33c-3 0-5 2-5 4.69s1.77 3.95 4.53 5.91 4.1 2.64 4.1 4.78c0 1.65-1 3.18-3.61 3.18a3.88 3.88 0 01-3.8-4h-2.18a5.9 5.9 0 005.95 6c3.67 0 5.69-2.33 5.69-5.27s-1.47-3.96-4.65-6.22z"
            className="cls-2 __blue"
          ></path>
          <path
            d="M83.54 30.74L87.49 30.74 87.49 46.74 83.54 46.74 83.54 48.88 93.58 48.88 93.58 46.74 89.63 46.74 89.63 30.74 93.58 30.74 93.58 28.6 83.54 28.6 83.54 30.74z"
            className="cls-2  __blue"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function MicrophoneGreen({ className }: any) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.41 30">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M10.21 22.08a6 6 0 006-6V6A6 6 0 004.17 6v10a6 6 0 006.04 6.08zm0-20a3.94 3.94 0 013.93 3.76h-2.89v2.08h2.92V10h-2.92v2.08h2.92v2.08h-2.92v2.08h2.89a3.94 3.94 0 01-7.87 0h2.89v-2.08H6.25v-2.08h2.91V10H6.25V7.92h2.91V5.84H6.27a4 4 0 013.94-3.76z"
            className="cls-1"
          ></path>
          <path d="M4.17 27.92H16.25V30H4.17z" className="cls-1"></path>
          <path
            d="M18.33 16a8.13 8.13 0 11-16.25 0H0a10.21 10.21 0 1020.41 0z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function MicrophoneNavy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.47 30.75">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M11.7 21.78H13.78V29.3H11.7z"
            className="cls-1"
            transform="rotate(-90 12.735 25.545)"
          ></path>
          <path
            d="M11.7 5.33H13.78V12.85H11.7z"
            className="cls-1"
            transform="rotate(-90 12.74 9.09)"
          ></path>
          <path
            d="M11.7 1.3H13.78V8.82H11.7z"
            className="cls-1"
            transform="rotate(-90 12.735 5.065)"
          ></path>
          <path
            d="M11.7 25.94H13.78V33.46H11.7z"
            className="cls-1"
            transform="rotate(-90 12.735 29.705)"
          ></path>
          <path
            d="M12.74 20.34A10.65 10.65 0 012.09 9.69H0a12.74 12.74 0 1025.47 0h-2.08a10.65 10.65 0 01-10.65 10.65z"
            className="cls-1"
          ></path>
          <path
            d="M12.74 16.24a6.55 6.55 0 01-6.55-6.55h-2a8.56 8.56 0 1017.11 0h-2a6.54 6.54 0 01-6.56 6.55z"
            className="cls-1"
          ></path>
          <path
            d="M9 12.07a4.44 4.44 0 007.53 0zM16.5 2.08a4.45 4.45 0 00-7.5 0z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function NewspaperGreen({ className }) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M29 0H19a5.06 5.06 0 00-5 5.05v22.87H2.08V2.08H11V0H1a1 1 0 00-1 1v28a1 1 0 001 1h28a1 1 0 001-1V1a1 1 0 00-1-1zm-1 27.92H16V5.05a3 3 0 013-3h8.91z"
            className="cls-1"
          ></path>
          <path d="M4.16 5.63H11.879999999999999V7.71H4.16z" className="cls-1"></path>
          <path d="M4.16 9.8H11.879999999999999V11.88H4.16z" className="cls-1"></path>
          <path d="M4.16 13.96H11.879999999999999V16.04H4.16z" className="cls-1"></path>
          <path
            d="M4.16 18.12H11.879999999999999V20.200000000000003H4.16z"
            className="cls-1"
          ></path>
          <path d="M4.16 22.28H11.879999999999999V24.36H4.16z" className="cls-1"></path>
          <path d="M18.12 5.63H25.84V7.71H18.12z" className="cls-1"></path>
          <path d="M18.12 9.8H25.84V11.88H18.12z" className="cls-1"></path>
          <path d="M18.12 13.96H25.84V16.04H18.12z" className="cls-1"></path>
          <path d="M18.12 18.12H25.84V20.200000000000003H18.12z" className="cls-1"></path>
          <path d="M18.12 22.28H25.84V24.36H18.12z" className="cls-1"></path>
        </g>
      </g>
    </svg>
  )
}

export function NewspaperNavy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.78 30.75">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M26.62 22.42L26.62 6.24 26.62 4.16 24.54 4.16 6.69 4.16 4.16 6.69 4.16 24.5 4.16 26.59 6.24 26.59 26.62 26.59 26.62 24.5 6.24 24.5 6.24 7.56 7.56 6.24 24.54 6.24 24.54 22.42 26.62 22.42z"
            className="cls-1"
          ></path>
          <path
            d="M30.78 0L30.78 0 28.7 0 4.97 0 0 4.97 0 28.67 0 30.75 2.08 30.75 30.78 30.75 30.78 28.67 2.08 28.67 2.08 5.83 5.83 2.08 28.7 2.08 28.7 26.59 30.78 26.59 30.78 2.08 30.78 2.08 30.78 0z"
            className="cls-1"
          ></path>
          <path d="M8.32 16.18H14.34V18.259999999999998H8.32z" className="cls-1"></path>
          <path d="M8.32 12.02H14.34V14.1H8.32z" className="cls-1"></path>
          <path d="M8.32 20.34H14.34V22.42H8.32z" className="cls-1"></path>
          <path d="M16.43 16.18H22.45V18.259999999999998H16.43z" className="cls-1"></path>
          <path d="M16.43 12.02H22.45V14.1H16.43z" className="cls-1"></path>
          <path d="M8.32 7.86H14.34V9.940000000000001H8.32z" className="cls-1"></path>
          <path d="M16.43 7.86H22.45V9.940000000000001H16.43z" className="cls-1"></path>
          <path d="M16.43 20.34H22.45V22.42H16.43z" className="cls-1"></path>
        </g>
      </g>
    </svg>
  )
}

export function PencilGreen({ className }) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.43 30">
      <g data-name="Layer 2">
        <path
          d="M30.4 28.71l-2.76-11.08a1 1 0 00-.27-.49L10.53.3a1.05 1.05 0 00-1.47 0L0 9.36l1.47 1.48L9.8 2.51l2.74 2.74L5 12.84a1 1 0 000 1.47l12.58 12.63a1 1 0 00.48.27L29.14 30a1.07 1.07 0 00.25 0 1.05 1.05 0 00.74-.31 1 1 0 00.27-.98zM21.08 22L9.93 10.81l1.31-1.31 11.15 11.15zm5-2l.64 2.58-3.78 3.78-2.58-.64zm-.91-2l-1.3 1.3L12.71 8 14 6.73zm-18-4.3l1.3-1.3 11.14 11.03-1.3 1.3zm18.12 13.17l2-2 .71 2.66z"
          className="cls-1"
          data-name="Layer 1"
        ></path>
      </g>
    </svg>
  )
}

export function PencilNavy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.05 30.75">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M21.38 7.36L19.91 5.89 7.36 18.43 7.36 18.43 5.89 19.91 7.36 21.38 16.73 30.75 23.75 30.75 23.75 28.67 17.59 28.67 8.83 19.91 19.91 8.83 29.97 18.89 29.97 24.5 29.97 30.75 32.05 30.75 32.05 24.5 32.05 18.03 21.38 7.36z"
            className="cls-1"
          ></path>
          <path
            d="M0.77 9.65H20.599999999999998V11.73H0.77z"
            className="cls-1"
            transform="rotate(-45 10.689 10.692)"
          ></path>
          <path
            d="M-2.17 6.71H17.659999999999997V8.79H-2.17z"
            className="cls-1"
            transform="rotate(-45 7.75 7.75)"
          ></path>
          <path
            d="M21.38 13.24L21.38 13.24 19.91 11.77 13.24 18.43 11.77 19.91 13.24 21.38 18.45 26.59 23.75 26.59 23.75 24.5 19.31 24.5 14.71 19.91 19.91 14.71 25.81 20.62 25.81 30.75 27.89 30.75 27.89 19.76 21.38 13.24z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function RightArrowGreen({ className }: SvgProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.42 18">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M3.03 1.27H7.470000000000001V3.35H3.03z"
            className="cls-1"
            transform="rotate(-135 5.25 2.307)"
          ></path>
          <path
            d="M0.09 4.21H4.53V6.29H0.09z"
            className="cls-1"
            transform="rotate(-135 2.308 5.247)"
          ></path>
          <path
            d="M7.54 11.95L2.96 16.53 4.43 18 9.01 13.42 13.42 9.01 11.95 7.54 7.54 11.95z"
            className="cls-1"
          ></path>
          <path
            d="M0.02 13.59L1.49 15.06 6.07 10.48 10.48 6.07 9.01 4.59 0.02 13.59z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function RightArrowNavy({ className, onClick }: any) {
  return (
    <svg
      onClick={() => onClick()}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.42 18"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M3.03 1.27H7.470000000000001V3.35H3.03z"
            className="cls-1"
            transform="rotate(-135 5.25 2.307)"
          ></path>
          <path
            d="M0.09 4.21H4.53V6.29H0.09z"
            className="cls-1"
            transform="rotate(-135 2.308 5.247)"
          ></path>
          <path
            d="M7.54 11.95L2.96 16.53 4.43 18 9.01 13.42 13.42 9.01 11.95 7.54 7.54 11.95z"
            className="cls-1"
          ></path>
          <path
            d="M0.02 13.59L1.49 15.06 6.07 10.48 10.48 6.07 9.01 4.59 0.02 13.59z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function UpArrowGreen() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 13.42">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M0.09 7.13H4.53V9.21H0.09z"
            className="cls-1"
            transform="rotate(135 2.308 8.173)"
          ></path>
          <path
            d="M3.03 10.08H7.470000000000001V12.16H3.03z"
            className="cls-1"
            transform="rotate(135 5.247 11.119)"
          ></path>
          <path
            d="M11.95 5.89L16.53 10.46 18 8.99 13.42 4.41 9.01 0 7.54 1.47 11.95 5.89z"
            className="cls-1"
          ></path>
          <path
            d="M13.59 13.4L15.06 11.93 10.48 7.36 6.07 2.94 4.59 4.41 13.59 13.4z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function UpArrowNavy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 13.42">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M0.09 7.13H4.53V9.21H0.09z"
            className="cls-1"
            transform="rotate(135 2.308 8.173)"
          ></path>
          <path
            d="M3.03 10.08H7.470000000000001V12.16H3.03z"
            className="cls-1"
            transform="rotate(135 5.247 11.119)"
          ></path>
          <path
            d="M11.95 5.89L16.53 10.46 18 8.99 13.42 4.41 9.01 0 7.54 1.47 11.95 5.89z"
            className="cls-1"
          ></path>
          <path
            d="M13.59 13.4L15.06 11.93 10.48 7.36 6.07 2.94 4.59 4.41 13.59 13.4z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function XGreen({ className }) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 13.42">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M0.09 7.13H4.53V9.21H0.09z"
            className="cls-1"
            transform="rotate(135 2.308 8.173)"
          ></path>
          <path
            d="M3.03 10.08H7.470000000000001V12.16H3.03z"
            className="cls-1"
            transform="rotate(135 5.247 11.119)"
          ></path>
          <path
            d="M11.95 5.89L16.53 10.46 18 8.99 13.42 4.41 9.01 0 7.54 1.47 11.95 5.89z"
            className="cls-1"
          ></path>
          <path
            d="M13.59 13.4L15.06 11.93 10.48 7.36 6.07 2.94 4.59 4.41 13.59 13.4z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function XNavy({ className, onClick, color = 'white' }) {
  return (
    <svg
      fill={color}
      onClick={() => onClick()}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.27 24.25"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M9.21 7.74L10.68 6.26 7.54 3.12 4.41 0 2.94 1.47 6.07 4.59 9.21 7.74z"
            className="cls-1"
          ></path>
          <path
            d="M6.26 10.68L7.74 9.21 4.59 6.07 1.47 2.94 0 4.41 3.12 7.54 6.26 10.68z"
            className="cls-1"
          ></path>
          <path
            d="M15.08 16.51L13.6 17.98 16.73 21.11 19.85 24.23 21.32 22.76 18.2 19.63 15.08 16.51z"
            className="cls-1"
          ></path>
          <path
            d="M17.8 13.66H19.880000000000003V18.08H17.8z"
            className="cls-1"
            transform="rotate(-45 18.842 15.866)"
          ></path>
          <path
            d="M20.93 16.78H23.009999999999998V21.200000000000003H20.93z"
            className="cls-1"
            transform="rotate(-45 21.963 18.983)"
          ></path>
          <path
            d="M24.27 4.41L22.79 2.94 19.67 6.07 15.09 10.64 15.09 10.64 6.08 19.65 6.08 19.65 2.96 22.77 4.43 24.25 7.56 21.12 12.13 16.55 21.14 7.54 24.27 4.41z"
            className="cls-1"
          ></path>
          <path
            d="M4.61 18.18L9.19 13.6 9.19 13.6 18.2 4.59 21.32 1.47 19.85 0 16.73 3.12 12.15 7.7 7.72 12.13 3.14 16.71 0.02 19.83 1.49 21.3 4.61 18.18 4.61 18.18z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function White() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.27 24.25">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M9.21 7.74L10.68 6.26 7.54 3.12 4.41 0 2.94 1.47 6.07 4.59 9.21 7.74z"
            className="cls-1"
          ></path>
          <path
            d="M6.26 10.68L7.74 9.21 4.59 6.07 1.47 2.94 0 4.41 3.12 7.54 6.26 10.68z"
            className="cls-1"
          ></path>
          <path
            d="M15.08 16.51L13.6 17.98 16.73 21.11 19.85 24.23 21.32 22.76 18.2 19.63 15.08 16.51z"
            className="cls-1"
          ></path>
          <path
            d="M17.8 13.66H19.880000000000003V18.08H17.8z"
            className="cls-1"
            transform="rotate(-45 18.842 15.866)"
          ></path>
          <path
            d="M20.93 16.78H23.009999999999998V21.200000000000003H20.93z"
            className="cls-1"
            transform="rotate(-45 21.963 18.983)"
          ></path>
          <path
            d="M24.27 4.41L22.79 2.94 19.67 6.07 15.09 10.64 15.09 10.64 6.08 19.65 6.08 19.65 2.96 22.77 4.43 24.25 7.56 21.12 12.13 16.55 21.14 7.54 24.27 4.41z"
            className="cls-1"
          ></path>
          <path
            d="M4.61 18.18L9.19 13.6 9.19 13.6 18.2 4.59 21.32 1.47 19.85 0 16.73 3.12 12.15 7.7 7.72 12.13 3.14 16.71 0.02 19.83 1.49 21.3 4.61 18.18 4.61 18.18z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function Plus({ className, onClick }: SvgProps) {
  return (
    <svg
      onClick={() => onClick()}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.05 28.05"
    >
      <g data-name="Layer 2">
        <path
          d="M4.42 13H0v-2.08h8.86V13zm4.44 4.16v-2.08H0v2.08h8.86zm10.35-2.11v2.08h8.84v-2.08h-8.84zm0-4.16V13h8.84v-2.11zM17.16 0h-2.08V28.05h2.08V0zM13 23.63V0h-2.09v28.05H13v-4.42z"
          className="cls-1"
          data-name="Layer 1"
        ></path>
      </g>
    </svg>
  )
}

export function HamburgerLine({ className, onClick }: SvgProps) {
  return (
    <svg
      onClick={e => onClick(e)}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.25 6.24"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path d="M0 0H24.25V2.08H0z" className="cls-1"></path>
          <path d="M0 4.16H24.25V6.24H0z" className="cls-1"></path>
        </g>
      </g>
    </svg>
  )
}

export const SvgController = ({ type, className }: any) => {
  switch (type) {
    case 'buyouts':
      return <BuyOutWhite className={className} />
    case 'infrastructure':
      return <InfrastructureWhite className={className} />
    default:
      return null
  }
}